import { render, staticRenderFns } from "./SpacingPrinciples.vue?vue&type=template&id=4a5111a0&"
import script from "./SpacingPrinciples.vue?vue&type=script&lang=js&"
export * from "./SpacingPrinciples.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports